import axios from '@/utils/api';

// переработать компонент layer-sync и выкинуть всю стору связанную с этим компонентом

const getSyncList = (
  params,
) => axios.get('admin/layer-object-syncs', { params });

const syncLayers = (
  layerIds,
) => axios.post('admin/layer-object-syncs/export', { layerIds }).then(res => res.data[0]);

const exportLayer = (
  layerId,
) => axios.post(
  'admin/layer-object-syncs/admin-export',
  { layerId },
  { responseType: 'blob' },
);

const getSyncLayer = (
  id,
) => axios.get(`admin/layer-object-syncs/${id}`);

const importLayer = (
  formData,
) => axios.post('admin/layer-object-syncs/import', formData, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export default {
  getSyncList,
  syncLayers,
  exportLayer,
  getSyncLayer,
  importLayer,
};
